<template>
  <step-display :current-step="0">
    <connect-google />
    <div class="text-center" v-if="$route.params.support">
      <a :href="siteUrl" target="_blank">Contact support</a>
    </div>
  </step-display>
</template>

<script>
import StepDisplay from "@/components/global/StepDisplay";
import ConnectGoogle from "@/components/steps/ConnectGoogleAccount";
import { AppConfig } from "@/config";

export default {
  name: "ConnectGoogleAccount",
  data() {
    return {
      siteUrl: AppConfig.siteUrl,
    }
  },
  components: {
    StepDisplay,
    ConnectGoogle,
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
a {
  display: block;
  text-align: center;
  color: $red;
  &:hover, &:active, &:hover {
    color: $orange;
  }
}

</style>